'use client';

import AnimatedTitleHero from '@/components/_rebrand/AnimatedTitleHero';
import MediaSection from '@/components/_rebrand/MediaSection';
import Modal from '@/components/_rebrand/Modal';
import { PageBumper } from '@/components/_rebrand/PageBumper';
import { UnpaddedRelatedContentCarousel } from '@/components/_rebrand/RelatedContentCarousel';
import { WhatsNewCta } from '@/components/_rebrand/WhatsNewCta';
import YouTubeVideo from '@/components/YouTubeVideo';
import { Fragment } from 'react';
import { useVideoModal } from './UntangledPage.hooks';
import {
  CoordinationTaxCtaProps,
  HeroProps,
  MainVideoProps,
  PageBumperProps,
  SeriesCarouselProps,
} from './UntangledPage.props';


export const UntangledPage = () => {
  const { activeVideoId, openVideoModal, closeVideo } = useVideoModal();

  return (
    <Fragment>
      <AnimatedTitleHero {...HeroProps} />

      <MediaSection
        {...MainVideoProps}
        onAssetClick={() => openVideoModal(MainVideoProps.videoId)}
      />

      <UnpaddedRelatedContentCarousel
        {...SeriesCarouselProps}
        onAssetClick={openVideoModal}
        className="py-margin-section-md"
      />

      <WhatsNewCta {...CoordinationTaxCtaProps} />

      <PageBumper {...PageBumperProps} />

      {activeVideoId && (
        <Modal name="Untangled Ops video" onClose={closeVideo} className='px-3xl pb-xs pt-3xl w-[90vw] max-w-grid'>
          <YouTubeVideo videoId={activeVideoId} showPlayButton={false} autoplay />
        </Modal>
      )}
    </Fragment>
  );
};

export default UntangledPage;
